import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import PaymentComponent from "../components/payment/payment";
import { BookingPageDetail } from "../pages/booking-page";
import { SeatBookingPage } from "../pages/seat-booking-page";
import ScrollToTop from "../utils/scrollTop";
import { Lounge } from "../components/service/subPages/lounge";
import { Luggage } from "../components/service/subPages/lugage";
import { Onboard } from "../components/service/subPages/onboard";
import { CustomerSatisfaction } from "../components/service/subPages/customer-satisfaction";
import { HowToBook } from "../components/service/subPages/how-to-book";
import { Sustainability } from "../components/service/subPages/sustainability";
import { CancellationPolicy } from "../components/service/subPages/cancellation-policy";
import { LuggagePriceList } from "../components/service/subPages/luggage-pricelist";
import PartnerWithUs from "../pages/partner";
import PostRideForm from "../components/PostRideForm";
import SearchRide from "../components/SearchRide";
import PostRequestForm from "../components/PostRequest";
import LoadingSpinner from "../components/LoadingSpinner";
import AndroidForm from "../components/AndroidForm";
import AdminForm from "../components/AdminForm";

const HomePage = lazy(() => import("../pages/home"));
const AboutPage = lazy(() => import("../pages/about"));
const AndroidAbout = lazy(() => import("../components/about/AndroidAbout"));
const ServicePage = lazy(() => import("../pages/services"));
const TermConditionPage = lazy(() => import("../pages/term-condition"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy"));
const AndroidPrivacyPolicy = lazy(() => import("../components/privacy-policy/AndroidPrivacyPolicy"));
const AndroidTermCondition = lazy(() => import("../components/termCondition/AndroidTermCondition"));
const LoginPage = lazy(() => import("../pages/login"));
const MyAccountPage = lazy(() => import("../pages/my-account"));
const BookingPage = lazy(() => import("../pages/booking"));
const BlogDetailPage = lazy(() => import("../pages/blog-detail"));
const AnnounceDetailPage = lazy(() => import("../pages/announce-detail"));
const ArticleDetailPage = lazy(() => import("../pages/article-detail"));

const ContactUsPage = lazy(() => import("../pages/contact"));
const BlogPage = lazy(() => import("../pages/blog"));
const ArticlePage = lazy(() => import("../pages/article"));

const AnnouncementPage = lazy(() => import("../pages/announcement"));

const LoginWithPhone = lazy(() => import("../components/login/LoginWithPhone"));
const Register = lazy(() => import("../components/register/Register"));
const ErrorPage = lazy(() => import("../pages/error"));
const DownloadPage = lazy(() => import("../components/DownloadPage"));

const MainRoutes = ({ setIsAuthenticated }) => {
  useEffect(() => {
    setIsAuthenticated(!!sessionStorage.getItem("auth"));
  }, []);

  const lazyWithSuspense = (Component) => (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  );

  return (
      <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={lazyWithSuspense(HomePage)} />
        <Route path="about-us" element={lazyWithSuspense(AboutPage)} />
        <Route path="about_us" element={lazyWithSuspense(AndroidAbout)} />
        <Route path="services" element={lazyWithSuspense(ServicePage)} />
        <Route path="Checkout" element={<PaymentComponent />} />
        <Route path="/term-condition" element={lazyWithSuspense(TermConditionPage)} />
        <Route path="/term_condition" element={lazyWithSuspense(AndroidTermCondition)} />
        <Route path="/privacy-policy" element={lazyWithSuspense(PrivacyPolicyPage)} />
        <Route path="/privacy_policy" element={lazyWithSuspense(AndroidPrivacyPolicy)} />
        <Route path="/partner-with-us" element={<PartnerWithUs />} />
        <Route path="/lounge" element={<Lounge />} />
        <Route path="/luggage-policy" element={<Luggage />} />
        <Route path="/safety-onboard" element={<Onboard />} />
        <Route path="/customer-satisfaction" element={<CustomerSatisfaction />} />
        <Route path="/how-to-book" element={<HowToBook />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/luggage-price-list" element={<LuggagePriceList />} />
        <Route path="/blog" element={lazyWithSuspense(BlogPage)} />
        <Route path="/blog-detail" element={lazyWithSuspense(BlogDetailPage)} />
        <Route path="/announcement" element={lazyWithSuspense(AnnouncementPage)} />
        <Route path="/announcement-detail" element={lazyWithSuspense(AnnounceDetailPage)} />
        <Route path="/article" element={lazyWithSuspense(ArticlePage)} />
        <Route path="/article-detail" element={lazyWithSuspense(ArticleDetailPage)} />
        <Route path="/booking-detail" element={<BookingPageDetail />} />
        <Route path="/seat-booking-page" element={<SeatBookingPage />} />
        <Route path="/services-on-our-vehicle" element={<Lounge />} />
        <Route path="register" element={lazyWithSuspense(Register)} />
        <Route
          path="login"
          element={
            process.env.REACT_APP_LOGIN_TYPE === "email"
              ? lazyWithSuspense(() => <LoginPage setIsAuthenticated={setIsAuthenticated} />)
              : lazyWithSuspense(LoginWithPhone)
          }
        />
        <Route
          path="profile"
          element={lazyWithSuspense(() => <MyAccountPage setIsAuthenticated={setIsAuthenticated} />)}
        />
        <Route
          path="booknow"
          element={lazyWithSuspense(() => <BookingPage setIsAuthenticated={setIsAuthenticated} />)}
        />
        <Route path="*" element={lazyWithSuspense(ErrorPage)} />
        <Route path="contact-us" element={lazyWithSuspense(ContactUsPage)} />
        <Route path="apps" element={lazyWithSuspense(DownloadPage)} />
        <Route path="booking" element={<AndroidForm/>} />
        <Route path="admin-booking">
          <Route index element={<AdminForm/>} />
          <Route path=":id" element={<AdminForm/>} />
        </Route>
        <Route path="post-ride">
          <Route index element={<PostRideForm />} />
          <Route path=":id" element={<PostRideForm />} />
        </Route>
        <Route path="post-request">
          <Route index element={<PostRequestForm />} />
          <Route path=":id" element={<PostRequestForm />} />
        </Route>
        <Route path="search-ride">
          <Route index element={<SearchRide />} />
        </Route>
      </Routes>
      </>
  );
};

export default MainRoutes;
